<table class="table">
    <thead>
        <tr>
            <th [ngStyle]="{ 'background': colorCabecera }" colspan="2">Dates</th>
            <th [ngStyle]="{ 'background': colorCabecera }" style="border-right: none;">&nbsp;</th>
            <th [ngStyle]="{ 'background': colorCabecera }" style="border-left-width: 0px;
            text-align: left;">Cruise</th>
            <th [ngStyle]="{ 'background': colorCabecera }">Length</th>
            <th [ngStyle]="{ 'background': colorCabecera }">Avail</th>
            <th [ngStyle]="{ 'background': colorCabecera }">Hold</th>
            <th [ngStyle]="{ 'background': colorCabecera }">Sold</th>
            <th [ngStyle]="{ 'background': colorCabecera }" style="width: 16%;">Promotion*</th>
            <th [ngStyle]="{ 'background': colorCabecera }" style="width: 10%;">Price pp. from</th>
            <th [ngStyle]="{ 'background': colorCabecera }">&nbsp;</th>

        </tr>
    </thead>
    <tbody>

      <ng-template ngFor let-c [ngForOf]="totalCruises" let-index="index">

        <tr *ngIf="!(isPromoOnly && c.promotionType ==  PROMO_RAC && !isCharterOnly)">
                <!-- COLUMN DATES -->
               <td class="month_{{ c.startDate | date: 'MMM' | lowercase }}" data-title='Month:'
                    style="vertical-align: middle" [ngStyle]="{'background': getColorbyMonth(c)}">
                    {{ c.startDate | date: 'MMM' | uppercase }}
                </td>
                <td data-label="Dates" class="tableDays" data-title='Dates:' style="vertical-align: middle;">
                    <span style="font-size: 19px;">{{ c.startDate | date: 'dd' }}-{{ c.endDate | date: 'dd' }}
                        <small *ngIf="(c.startDate | date: 'MMM') != (c.endDate | date: 'MMM')"> {{ c.endDate | date:
                            'MMM'}}</small>
                    </span>

                    <em>
                        {{ c.startDate | date: 'EEE' | uppercase }} - {{ c.endDate | date: 'EEE' | uppercase }}
                        <a (click)="openItineraryDetailsModal(c.boat, c)" style="cursor: pointer;">
                        ({{ c.name }})
                        </a>
                    </em>
                </td>
                <!-- CRUISE IMAGE -->
                <td class="tableDays" data-title="Image:" data-label="Image:" style="border-right: none;">
                    <a href="{{c.boat.webLink}}" target="_blank" (click)="addLogDetails(c.boat.name)">
                        <img lazyLoad="{{logoCruise}}{{c.boat.image }}" width="129" height="65" class="boat"
                            alt="c.boat.imageBoat"
                            defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
                    </a>
                </td>

                <!-- COLUMN CRUISE -->
                <td class="tableDays" data-label="Cruise:" style="vertical-align: middle; text-align: left;">
                    <a href="{{c.boat.webLink}}" class="boatlnk" target="_blank" (click)="addLogDetails(c.boat.name)">
                        {{ c.boat.name }}
                        <div>
                            <img src="assets/images/black-arrow.png" class="arrw" />
                            <img lazyLoad="{{logoCruise}}{{c.boat.image }}" class="boat" alt="c.boat.imageBoat"
                                defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
                        </div>
                    </a>

                </td>
                <!-- COLUMN LENGTH -->
                <td class='tblDaysCol' data-label="Length:" style="vertical-align: middle;">
                    {{ c.length }}
                </td>
                <!-- COLUMN AVAIL -->
                <td class="tblDaysCol" data-label="Available:" style="vertical-align: middle;">
                    <span *ngIf="c.avail == 0">{{ c.avail }}</span>
                    <i class={{getClassTool(c.cabinsAvailable.length)}} *ngIf=" c.avail > 0">
                        {{ c.avail }}
                        <span class="tooltiptext" *ngIf="c.cabinsAvailable.length>0">
                            <img src="assets/images/black-arrow.png" />
                            <!--<p>Cabins available by type/deck:</p>-->
                            <ul>
                                <li *ngFor="let cAvail of c.cabinsAvailable"><strong>{{ cAvail}}</strong></li>

                            </ul>
                        </span>
                    </i>
                </td>
                <!-- COLUMN HOLD -->
                <td class="tblDaysCol" data-label="Hold:" style="vertical-align: middle;">
                    <span *ngIf="c.hold == 0">{{ c.hold }}</span>
                    <i class={{getClassTool(c.cabinsOnHold.length)}} *ngIf="c.hold > 0">
                        {{ c.hold }}
                        <span class="tooltiptext" *ngIf="c.cabinsOnHold.length>0">
                            <img src="../../../assets/images/black-arrow.png" />
                            <!--<p>Cabins hold by type/deck:</p>-->
                            <ul>
                                <li *ngFor="let cOnHold of c.cabinsOnHold"><strong>{{ cOnHold }}</strong></li>

                            </ul>
                        </span>
                    </i>
                </td>
                <!-- COLUMN SOLD -->
                <td class="tblDaysCol" data-label="Sold:" style="vertical-align: middle;">
                    <span>{{ c.sold }}</span>
                </td>
                <!-- COLUMN PROMOTIONS -->
                <td class="tablePromos" data-label="Promotion:" style="vertical-align: middle;"
                    [ngStyle]="{'color': colorSecundario}">

                    <div *ngIf="isCharterOnly">
                        <div *ngIf="c.promotionType == PROMO_NET">SPECIAL PRICE</div>
                        <div *ngIf="doesAplyCharter(c.charterOnly, c.boat.passengers, c.avail)">
                            {{getTextPrivateCharter()|titlecase}}</div>
                        <div *ngIf="!doesAplyCharter(c.charterOnly, c.boat.passengers, c.avail)">
                            {{getTextCharterOnlyWithFilterCharter()}}</div>
                        <div *ngIf="!isFamilyDeparture(c.remarks | remarks)">{{ c.remarks | remarks }}</div>
                        <div *ngIf="isFamilyDeparture(c.remarks | remarks)">
                            <i class="tool" [ngStyle]="{'font-weight': (isFamilyDeparture(c.remarks | remarks))?'bold':'none',
                            'border':'none'}">{{
                                c.remarks |
                                remarks }}
                                <span class="tooltiptext" *ngIf="isFamilyDeparture(c.remarks | remarks)" [ngStyle]="{'width':'250px'}">
                                    <img src="../../../assets/images/black-arrow.png" />
                                    <ul>
                                        <li>Additional Naturalist Guide for kids</li>
                                        <li>Fun onboard activities</li>
                                        <li>Galapagos educational presentations</li>
                                        <li>Delicious kid friendly meals and more...</li>
                                    </ul>
                                </span>
                            </i>
                        </div>
                        <div style="font-weight: 800;">{{ renderTextPromotion( c ) }}</div>
                        <span style="color: #10707f" *ngFor="let srv of c.aditionalServices">
                            {{ srv }} *
                        </span>
                    </div>

                    <div *ngIf="!isCharterOnly">

                        <div *ngIf="c.promotionType == PROMO_NET">SPECIAL PRICE</div>
                        <div *ngIf="c.groupsOnly">GROUPS ONLY</div>
                        <div *ngIf="c.charterOnly && !isXmasPromo(c)">{{getTextCharterOnlyWithFilterCharter()}}</div>
                        <div *ngIf="!isFamilyDeparture(c.remarks | remarks)">{{ c.remarks | remarks }}</div>
                        <div *ngIf="isFamilyDeparture(c.remarks | remarks)">
                            <i class="tool" [ngStyle]="{'font-weight': (isFamilyDeparture(c.remarks | remarks))?'bold':'none',
                            'border':'none'}">{{
                                c.remarks |
                                remarks }}
                                <span class="tooltiptext" *ngIf="isFamilyDeparture(c.remarks | remarks)" [ngStyle]="{'width':'250px'}">
                                    <img src="../../../assets/images/black-arrow.png" />
                                    <ul>
                                        <li>Additional Naturalist Guide for kids</li>
                                        <li>Fun onboard activities</li>
                                        <li>Galapagos educational presentations</li>
                                        <li>Delicious kid friendly meals and more...</li>
                                    </ul>
                                </span>
                            </i>
                        </div>
                        <div style="font-weight: 800;">{{ renderTextPromotion( c ) }}</div>
                        <span style="color: #10707f" *ngFor="let srv of c.aditionalServices">
                            {{ srv }} *
                        </span>
                    </div>


                </td>
                <!-- COLUMN PRICES -->
                <td data-label="Price from:" class="tablePrice"
                    style="vertical-align: middle; padding:2px; font-size: 14px;">
                    <!-- IS SEARCHED CHARTER ONLYS -->
                    <div *ngIf="isCharterOnly">
                        <!--Valor Original para Charter-->
                        <div class="was"
                            *ngIf="c.charterPrice != c.charterPricePromo  && c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
                            US$ {{ c.charterPrice | number:'3.0-0' }}
                        </div>

                        <!--Valor Charter Promo-->
                        <div id="priceCharter" class="tool-withouttiptext"
                            *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
                            US$ {{ c.charterPricePromo | number:'3.0-0' }}
                        </div>
                        <!--Valor Charter Rack-->
                        <div class="tool-withouttiptext">
                          <span *ngIf="isXmasPromo(c) == false && (c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) ">
                            US$ {{ c.charterPrice | number:'3.0-0' }} </span>
                              <span class="xmas-text" *ngIf="isXmasPromo(c) == true">
                              <a href="https://www.royalgalapagos.com/forms/en/{{c.boat.pathFriendly}}/1" target="_blank">Contact us for more info</a>
                             </span>
                        </div>
                    </div>
                    <!-- IS SEARCHED DEFAULT OPTIONS -->
                    <div *ngIf="!isCharterOnly">

                        <!--Valor Original por Persona-->
                        <div class="was" *ngIf="c.promotionPrice != c.rackPrice && !c.charterOnly">
                            US$ {{ c.rackPrice | number:'3.0-0' }}
                        </div>
                        <!--Valor Original para Charter-->
                        <div class="was"
                            *ngIf="c.charterPrice != c.charterPricePromo && c.charterOnly && c.charterPromotionType != PROMO_RAC && c.promotionType != PROMO_NET">
                            US$ {{ c.charterPrice | number:'3.0-0' }}
                        </div>
                        <!--Valor por Persona-->
                        <div *ngIf="!c.charterOnly" class="tool-withouttiptext">
                            <span *ngIf="isXmasPromo(c) == false && c.cabinsAvailablePrices?.length == 0">US$ {{ c.promotionPrice | number:'3.0-0' }}</span>
                            <span class="xmas-text" *ngIf="isXmasPromo(c) == true">
                              <a href="https://www.royalgalapagos.com/forms/en/{{c.boat.pathFriendly}}/1" target="_blank">Contact us for more info</a>
                             </span>
                            <span class="tool" *ngIf="c.cabinsAvailablePrices?.length !== 0 && !isXmasPromo(c)">
                                US$ {{ c.promotionPrice | number:'3.0-0' }}
                                <span class="tooltiptext" style="min-width: 300px;">
                                    <img src="assets/images/black-arrow.png" />
                                    <ul>
                                        <li *ngFor="let pr of c.cabinsAvailablePrices"><strong>{{pr}} </strong></li>
                                    </ul>
                                </span>
                            </span>
                        </div>
                        <!--Valor Charter Promo-->
                        <div id="priceCharter" class="tool-withouttiptext"
                            *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET && c.charterOnly ">
                            US$ {{ c.charterPricePromo | number:'3.0-0' }}
                        </div>
                        <!--Valor Charter Rack-->
                        <div id="priceCharterRack" class="tool-withouttiptext"
                            *ngIf="(c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) && c.charterOnly">
                            <span *ngIf="isXmasPromo(c) == false">US$ {{ c.charterPrice | number:'3.0-0' }}</span>
                            <span class="xmas-text" *ngIf="isXmasPromo(c) == true">
                              <a href="https://www.royalgalapagos.com/forms/en/{{c.boat.pathFriendly}}/1" target="_blank">Contact us for more info</a>
                             </span>
                        </div>
                    </div>
                </td>
                <!-- COLUMN OPTIONS -->
                <td class="tblInquireCol" style="vertical-align: middle;">
                     <a *ngIf="isXmasPromo(c) == false && ((datesCompany.visibleEcommerce && validateBookNowButton(c.boat, c)) || datesCompany.visibleEcommerce && isVisibleOnhold(c)) && !doesAplyCharter(isCharterOnlyOrSearchedCharter(c), c.boat.passengers, c.avail)
                    && !isCharterOnlyOrSearchedCharter(c)"
                        (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
                        isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice,
                         isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate, c.endDate, c.length, c.name,
                         passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices, isCharterOnlyOrSearchedCharter(c), c.groupsOnly)"
                        href="{{ env.pathEcommerceGalavail }}/{{ empresa }}/{{ selectedCode }}/{{ passengers }}/{{ dataCodeEncrypt }}"
                        class="inq" [ngStyle]="{ 'background-color': colorSecundario }">Book Now</a>
                        <a *ngIf=" isXmasPromo(c) == false && datesCompany.visibleInquire && !isCharterOnlyOrSearchedCharter(c)" (click)="isVisibleDialog=true;  setSelectedOption(c.boat, c)"
                        style="cursor: pointer;" class="sml"
                        href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/fit/1"
                        (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
                        isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice,
                        isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate, c.endDate, c.length, c.name,
                        passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices, isCharterOnlyOrSearchedCharter(c), c.groupsOnly)"> INQUIRE HERE </a>
                        <a *ngIf="isXmasPromo(c) == false  && datesCompany.visibleInquire && isCharterOnlyOrSearchedCharter(c)" (click)="isVisibleDialog=true;  setSelectedOption(c.boat, c)"
                        style="cursor: pointer;" class="sml"
                        href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/charter/0">
                          INQUIRE HERE
                        </a>
                        <a *ngIf="isXmasPromo(c)" href="https://www.royalgalapagos.com/forms/en/{{c.boat.pathFriendly}}/1" style="cursor: pointer;" class="sml"  target="_blank">INQUIRE HERE</a>
                </td>

            </tr>


            <tr *ngIf="doesAplyCharterOption(c.charterOnly, c.boat.passengers, c.avail , c ) && c.charterPrice!=0">
                <!-- COLUMN DATES -->
                <td class="month_{{ c.startDate | date: 'MMM' | lowercase }}" data-title='Month:'
                    style="vertical-align: middle;" [ngStyle]="{'background': getColorbyMonth(c)}">
                    {{ c.startDate | date: 'MMM' | uppercase }}</td>
                <td data-label="Dates" class="tableDays" data-title='Dates:' style="vertical-align: middle;">
                    <span style="font-size: 19px;">{{ c.startDate | date: 'dd' }}-{{ c.endDate | date: 'dd' }} <small
                            *ngIf="(c.startDate | date: 'MMM') != (c.endDate | date: 'MMM')"> {{ c.endDate | date: 'MMM'
                            }}</small></span>

                    <em>
                        {{ c.startDate | date: 'EEE' | uppercase }} - {{ c.endDate | date: 'EEE' | uppercase }}
                        ({{ c.name }})
                    </em>
                </td>
                <!-- CRUISE IMAGE -->
                <td class="tableDays" data-title="Image:" style="border-right: none;">
                    <a href="{{c.boat.webLink}}" target="_blank">
                        <img lazyLoad="{{logoCruise}}{{c.boat.image }}" width="129" height="65" class="boat"
                            alt="c.boat.imageBoat"
                            defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
                    </a>
                </td>
                <!-- COLUMN CRUISE -->
                <td class="tableDays" data-label="Cruise:" style="vertical-align: middle; text-align: left;">
                    <a href="{{c.boat.webLink}}" class="boatlnk" target="_blank"> {{ c.boat.name }}
                        <div>
                            <img src="assets/images/black-arrow.png" class="arrw" />
                            <img lazyLoad="{{logoCruise}}{{c.boat.image }}" class="boat" alt="c.boat.imageBoat"
                                defaultImage="https://dev.frontend.galavail.com/assets/images/no-disponible.gif" />
                        </div>
                    </a>

                </td>
                <!-- COLUMN LENGTH -->
                <td class='tblDaysCol' data-label="Length:" style="vertical-align: middle;">
                    {{ c.length }}
                </td>
                <!-- COLUMN AVAIL -->
                <td class="tblDaysCol" data-label="Available:" style="vertical-align: middle;">
                    <span *ngIf="c.avail == 0">{{ c.avail }}</span>
                    <i class={{getClassTool(c.cabinsAvailable.length)}}  *ngIf=" c.avail > 0">
                        {{ c.avail }}
                        <span class="tooltiptext" *ngIf="c.cabinsAvailable.length>0">
                            <img src="assets/images/black-arrow.png" />
                            <!--<p>Cabins available by type/deck:</p>-->
                            <ul>
                                <li *ngFor="let cAvail of c.cabinsAvailable"><strong>{{ cAvail}}</strong></li>

                            </ul>
                        </span>
                    </i>
                </td>
                <!-- COLUMN HOLD -->
                <td class="tblDaysCol" data-label="Hold:" style="vertical-align: middle;">
                    <span *ngIf="c.hold == 0">{{ c.hold }}</span>
                    <i class={{getClassTool(c.cabinsOnHold.length)}}  *ngIf="c.hold > 0">
                        {{ c.hold }}
                        <span class="tooltiptext" *ngIf="c.cabinsOnHold.length>0">
                            <img src="../../../assets/images/black-arrow.png" />
                            <!--<p>Cabins hold by type/deck:</p>-->
                            <ul>
                                <li *ngFor="let cOnHold of c.cabinsOnHold"><strong>{{ cOnHold }}</strong></li>

                            </ul>
                        </span>
                    </i>
                </td>
                <!-- COLUMN SOLD -->
                <td class="tblDaysCol" data-label="Sold:" style="vertical-align: middle;">
                    <span>{{ c.sold }}
                        <!--span class="tooltiptext" style="min-width: 190px;">
                            <img src="assets/images/black-arrow.png" />
                            <p *ngIf="c.cabinsAvailablePrices?.length !== 0" style="margin-bottom: 0px;">
                                Avaible
                            </p>
                            <ul >
                                <li *ngFor="let pr of c.cabinsAvailablePrices" ><strong>{{pr}} </strong></li>
                            </ul>
                            <p *ngIf="c.cabinsOnHoldPrices?.length !== 0" style="margin-bottom: 0px;">
                                Hold
                            </p>
                            <ul>
                                <li *ngFor="let pr of  c.cabinsOnHoldPrices" ><strong>{{pr}} </strong></li>
                            </ul>
                        </!--span-->
                    </span>
                </td>
                <!-- COLUMN PROMOTIONS -->
                <td class="tablePromos" data-label="Promotion:" style="vertical-align: middle;"
                    [ngStyle]="{'color': colorSecundario}">

                    <div>
                        <div *ngIf="c.charterPromotionType == PROMO_NET">SPECIAL PRICE</div>
                        <div>{{getTextPrivateCharter()|titlecase}}</div>
                        <div *ngIf="!isFamilyDeparture(c.remarks | remarks)">{{ c.remarks | remarks }}</div>
                        <div *ngIf="isFamilyDeparture(c.remarks | remarks)">
                            <i class="tool" [ngStyle]="{'font-weight': (isFamilyDeparture(c.remarks | remarks))?'bold':'none',
                            'border':'none'}">{{
                                c.remarks |
                                remarks }}
                                <span class="tooltiptext" *ngIf="isFamilyDeparture(c.remarks | remarks)" [ngStyle]="{'width':'250px'}">
                                    <img src="../../../assets/images/black-arrow.png" />
                                    <ul>
                                        <li>Additional Naturalist Guide for kids</li>
                                        <li>Fun onboard activities</li>
                                        <li>Galapagos educational presentations</li>
                                        <li>Delicious kid friendly meals and more...</li>
                                    </ul>
                                </span>
                            </i>
                        </div>
                        <div style="font-weight: 800;">{{ renderTextPromotion( c, true ) }}</div>
                        <span style="color: #10707f" *ngFor="let srv of c.aditionalServices">
                            {{ srv }} *
                        </span>
                    </div>



                </td>
                <!-- COLUMN PRICES -->
                <td data-label="Price from:" class="tablePrice"
                    style="vertical-align: middle; padding:2px; font-size: 14px;">
                    <!-- IS SEARCHED CHARTER ONLYs -->
                    <div class="price">
                        <!--Valor Original para Charter-->
                        <div class="was"
                            *ngIf="c.charterPrice != c.charterPricePromo  && c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
                            US$ {{ c.charterPrice | number:'3.0-0' }}
                        </div>

                        <!--Valor Charter Promo-->
                        <div class="tool-withouttiptext" id="priceCharter"
                            *ngIf="c.charterPromotionType != PROMO_RAC && c.charterPromotionType != PROMO_NET">
                            US$ {{ c.charterPricePromo | number:'3.0-0' }}
                        </div>
                        <!--Valor Charter Rack-->
                        <div class="tool-withouttiptext">
                            <span *ngIf="!isXmasPromo(c) && (c.charterPromotionType == PROMO_RAC || c.charterPromotionType == PROMO_NET) ">
                              US$ {{ c.charterPrice | number:'3.0-0' }} </span>
                            <span class="xmas-text" *ngIf="isXmasPromo(c) == true">
                              <a href="https://www.royalgalapagos.com/forms/en/{{c.boat.pathFriendly}}/1" target="_blank">Contact us for more info</a></span>
                        </div>
                    </div>
                </td>

                <!-- COLUMN OPTIONS -->
                  <td class="tblInquireCol" style="vertical-align: middle;">
                    <a *ngIf="datesCompany.visibleInquire"
                        href="{{ empresa }}/inquire/{{ dataCodeEncrypt }}/{{ c.code }}/charter/0" class="inq"
                        [ngStyle]="{ 'background-color': colorSecundario }"
                        (click)="setParametersInquire( c.code, empresa, c.boat.name, renderTextPromotion(c), isCharterOnlyOrSearchedCharter(c) ? 'Charter' : 'none',
                    isCharterOnlyOrSearchedCharter(c) ? c.charterPrice : c.rackPrice,
                     isCharterOnlyOrSearchedCharter(c) ? c.charterPricePromo : c.promotionPrice, c.startDate, c.endDate, c.length, c.name,
                     passengers, c.startEndDates, c.boat.logo, c.boat.image, c.aditionalServices, isCharterOnlyOrSearchedCharter(c), c.groupsOnly)">Inquire Here</a>

                </td>
            </tr>
        </ng-template>
    </tbody>
</table>

<gal-modal *ngIf="selectedAvailability && selectedCruise" [visible]="false" [closable]="true" [modalWidth]="'30vw'"
    (modalClosed)="isVisibleDialog=false; visibleAlertText= false">
    <div class="content-modal">
        <div class="title-modal">
            <h3> I want to:</h3>
        </div>
        <div class="message-modal">
            <div class="container">
                <div class="row" style="display: flex;">
                    <div class="col-sm"
                        *ngIf="(datesCompany.visibleEcommerce && validateBookNowButton(selectedCruise, selectedAvailability))">
                        <a class="inq ng-star-inserted buttonBookNow" style="  width: 114px;  text-align: center;"
                            id="buttonShare" [ngStyle]="{ 'background-color': colorSecundario }"
                            href="{{ env.pathEcommerceGalavail }}/{{ empresa }}/{{ selectedCode }}/{{ passengers }}/{{ dataCodeEncrypt }}">
                            <b>
                                Book and Pay now
                            </b>
                        </a>
                    </div>
                    <div class="col-sm">
                        <a class="inq ng-star-inserted buttonBookNow" style="width: 114px;  text-align: center;"
                            id="buttonPlace" [ngStyle]="{ 'background-color': colorSecundario }"
                            (click)="goAndValidateOnhold(selectedAvailability)">
                            <b>
                                Place on Hold
                            </b>
                        </a>
                    </div>

                </div>
                <br>
                <div class="w3-panel w3-pale-red w3-border" id="alert-design" *ngIf="visibleAlertText">
                    {{textAlart}} <br>
                    <br>
                    <a (click)="visibleAlertText = false" style="cursor: pointer;
                  text-align: center;
                  width: fit-content;" [ngStyle]="{ 'background-color': colorSecundario }"> Accept</a>
                </div>

            </div>

        </div>

    </div>
</gal-modal>

<gal-modal [visible]="isVisibleDialogItinerary" [closable]="true" [modalWidth]="'55rem'"
  *ngIf="isVisibleDialogItinerary" (modalClosed)="isVisibleDialogItinerary=false">
  <ng-container *ngIf="loadingItineryDetail">
    <app-loading-itinerary-details></app-loading-itinerary-details>
    <!-- <div _ngcontent-hmy-c5="" class="headmod" id="idHeader"[ngStyle]="{ 'background-color': colorSecundario, 'color': '#fff' }" >
     loading ...
    </div> -->
  </ng-container>
  <ng-container *ngIf="!loadingItineryDetail">


    <div _ngcontent-hmy-c5="" class="headmod" id="idHeader"
      [ngStyle]="{ 'background-color': colorCabecera, 'color': '#fff' }">
      {{selectedAvailability.length}}- Itinerary: {{ selectedAvailability.startDate | date: 'EEE' | uppercase }} - {{
      selectedAvailability.endDate | date: 'EEE' | uppercase }} {{itinerarySelect.length}}({{itinerarySelect.name}})
    </div>
    <div class="content-modal" style="display: flex;">
      <div style="flex: 2;">
        <h4>
          {{ selectedAvailability.startDate | date: 'MMM' }} {{ selectedAvailability.startDate | date: 'dd' }}-{{
          selectedAvailability.endDate | date: 'dd' }}, {{ selectedAvailability.startDate | date: 'y' }}
        </h4>
        <app-itinerary-details [itineraries]="this.itineraries" [className]="'tab-itinerary'" style="width: 100%;"
          [isIncludeTableHeader]="false" [itineraryDescription]="this.itinerarySelect.description"></app-itinerary-details>
      </div>
      <div style="flex: 1;">
        <img class="img-fluid mb-3"
          [src]="this.itinerarySelect.images.length > 0 ?(imgItinerariesResourceUrl + this.itinerarySelect.images[ 0 ]) : null"
          width="400" height="300" alt="image">
      </div>
    </div>
    <div class="content-modal" style="display: flex; color: #fff;justify-content: end;">
      <button [ngStyle]="{ 'background-color': colorSecundario }" color="white" mat-button
        (click)="isVisibleDialogItinerary=false">
        Accept
      </button>
    </div>
  </ng-container>
</gal-modal>
